<template>
    <!--积分规则-->
  <div id="rulesign">
    <h2 class="title">
      <a @click="back" class="prev"></a>
      积分规则
    </h2>
    <!--
    <div class="rule">
      <h3>如何使用</h3>
      <p>
        1. 购课抵现<br>
        部分课程购买时可使用积分抵扣现金，1000积分可以抵扣 1元人民币。<br>
        2. 参加活动<br>
        不定期会有官方举办的活动，可以用积分参与活动。
      </p>
    </div>
    <hr>
    <div class="rule">
      <h3>如何获得</h3>
      <p>
        1. 每日签到<br>
        部分课程购买时可使用积分抵扣现金，1000积分可以抵扣 1元人民币。<br>
        2. 每日任务<br>
        不定期会有官方举办的活动，可以用积分参与活动。
      </p>
    </div>
    <hr>
    <div class="rule">
      <h3>注意事项</h3>
      <p>
        1. 每日签到<br>
        部分课程购买时可使用积分抵扣现金，1000积分可以抵扣 1元人民币。<br>
        2. 参加活动<br>
        不定期会有官方举办的活动，可以用积分参与活动。
      </p>
    </div>
    -->
    <div class="rule" v-html="textData"></div>
  </div>
</template>

<script>
export default {
  name: 'RuleSign',
  data () {
    return {
      textData: {}
    }
  },
  methods: {
    getText () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_rule_integral',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          this.textData = res.data
        })
        .catch(err => { console.log(err) })
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  },
  mounted () {
    this.getText()
  }
}
</script>

<style scoped lang="stylus">
  #rulesign
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      border-bottom: .02rem solid #E7E8E9
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    .rule
      padding: .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      h3
        font-size: .28rem
        color: #333
        font-weight: 500
        &::before
          content: ""
          position: relative
          top: .02rem
          display: inline-block
          width: .28rem
          height: .28rem
          background: url(../../assets/icon/rulevip_icon_h3.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
          margin-right: .1rem
      p
        margin: .18rem 0
        line-height: .45rem
        font-size: .26rem
        color: #A3A9B7
      & + hr
        height: .16rem
        background-color: #F9F9F9
        border: none
        margin: 0
</style>



// WEBPACK FOOTER //
// src/components/single/RuleSign.vue